import { Modal } from "antd";
import { request, gql } from "graphql-request";

const graphQlApi =
  "https://api-us-east-1-shared-usea1-02.hygraph.com/v2/clj7luofp0rdu01t65huw3xb4/master";

export const createEmail = async (email) => {
    const success = () => {
        Modal.success({
          content: "You've Subscribed Successfully!",
        });
      };
      const error1 = (errorr) => {
        Modal.error({
          content: "Something went wrong or you've already subscribed!",
        });
      };
  const mutation = gql`
    mutation MyMutation($email: String!) {
      createEmail(data: { email: $email }) {
        email
      }
    }
  `;

  const variables = {
    email: email,
  };

  try {
    const response = await request(graphQlApi, mutation, variables);
    success()
    return response;
  } catch (error) {
    console.error(error);
    error1(error)
  }
};
